export enum EnumSystemLockType {
  PROGRAM_ORDER = 'PROGRAM_ORDER',
}
